module.exports = __webpack_public_path__ + "img/balance_sheet_manual_4.946a32de.png";